<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <figure class="site-surface-card px-6 py-8 sm:px-10">
    <blockquote class="site-display text-xl leading-snug tracking-tight sm:text-2xl">
      “{{ data.quote }}”
    </blockquote>
    <figcaption
      v-if="data.author"
      class="mt-4 flex items-center gap-3"
    >
      <img
        v-if="data.avatar"
        :src="data.avatar"
        :alt="data.author"
        class="size-10 rounded-full object-cover"
      >
      <div>
        <p class="text-sm font-semibold">
          {{ data.author }}
        </p>
        <p
          v-if="data.role"
          class="text-xs text-[var(--site-muted)]"
        >
          {{ data.role }}
        </p>
      </div>
    </figcaption>
  </figure>
</template>
